import {ImpuestoDTO} from '../ImpuestoDTO';
import {TipoRetencionDTO} from '../TipoRetencionDTO';
import {TipoCFEDTO} from '../TipoCFEDTO';
import {FormaPagoDTO} from '../FormaPagoDTO';
import {TiposPesoDTO} from '../TiposPesoDTO';

export class DatosInicioDetalleCFEDTO
{
  esModoEResguardo: boolean;
  impuestosDTOs: Array<ImpuestoDTO>;
  tiposRetencionesDTOs: Array<TipoRetencionDTO>;
  tiposCFEsDTOs: Array<TipoCFEDTO>;
  codigoImpuestoSeleccionado: number;
  codigoTipoRetencionSeleccionado: number;
  codigoTipoCFESeleccionado: number;
  tiposPesoDTOs: Array<TiposPesoDTO>;
}
